import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client";
import LocalStorageService from "../services/localstorage.service";
import { PermissionsType } from "../types/permissions";


const client = new HTTPClient();

export interface PermissionsFilters {
    page: number;
    limit: number;
}

export interface PermissionResponse {
    permissions?: {
        data : Array<PermissionsType>;
    };
    total?: number;
    error?: string;
}

class PermissionsModel {
    static async getAll(filters: PermissionsFilters){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/permissions?page=${filters.page}&limit=${filters.limit}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as PermissionResponse
    }
}

export default PermissionsModel